<mat-toolbar color="primary" class="apearAnimation flex-row flex content-between relative rounded-md">
  <span class="font-semibold">Ingresos</span>
</mat-toolbar>

<div class="margin-container apearAnimation">
  <div class="flex flex-wrap items-baseline bg-stone-100 rounded-md pt-3 px-1 mb-2">
    <mat-form-field appearance="outline" style="width: 450px;">
      <mat-label>Periodo de busqueda</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate [(ngModel)]="startDate" placeholder="Fecha desde" />
        <input matEndDate [(ngModel)]="endDate" placeholder="Fecha hasta" />
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="example-full-width" style="padding-left: 10px; font-size: smaller;">
      <mat-label>Disciplina</mat-label>
      <mat-select [(ngModel)]="disciplinaSelect" >
        <mat-option> Todas las disciplinas</mat-option>
        <mat-option *ngFor="let disciplinaTmp of lstDisciplinas" [value]="disciplinaTmp.id">
          {{disciplinaTmp.nombre}}
        </mat-option>
      </mat-select>

    </mat-form-field>
    <button style="margin-left: 10px;" (click)='buscar()' mat-raised-button color="primary">Buscar</button>
  </div>

  <div class="loading-indicator" *ngIf="isLoadingResults">
    <mat-spinner></mat-spinner>
  </div>

  <mat-form-field appearance="outline" >
    <mat-label>Filtro</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Filtro" #input />
  </mat-form-field>

  <div class="mat-elevation-z0 contenedorTabla" *ngIf="!isLoadingResults">
    <table mat-table [dataSource]="dataSource">
      <!--       <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>No.</th>
              <td mat-cell *matCellDef="let element">{{ element.id }}</td>
            </ng-container> -->

      <ng-container matColumnDef="nombre">
        <th mat-header-cell *matHeaderCellDef>Nombre</th>
        <td mat-cell *matCellDef="let element">{{ element.nombre }}</td>
      </ng-container>

      <!--         <ng-container matColumnDef="club">
            <th mat-header-cell *matHeaderCellDef>Club</th>
            <td mat-cell *matCellDef="let element">{{ element.empresa }}</td>
          </ng-container> -->

      <ng-container matColumnDef="disciplina">
        <th mat-header-cell *matHeaderCellDef>Disciplina</th>
        <td mat-cell *matCellDef="let element">{{ element.disciplina }}</td>
      </ng-container>

      <ng-container matColumnDef="fecha">
        <th mat-header-cell *matHeaderCellDef>Fecha</th>
        <td mat-cell *matCellDef="let element">
          {{ element.fecha | date: "dd-MM-yyyy HH:mm" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="resultado">
        <th mat-header-cell *matHeaderCellDef>Resultado</th>
        <td mat-cell *matCellDef="let element">
          <label *ngIf="element.resultado"> Ingreso </label>
          <label *ngIf="!element.resultado"> No ingreso </label>
          <mat-icon 
          *ngIf="!element.resultado"
          matTooltip="{{getTextoCodigoNoIngreso(element.codigoNoIngreso)}}"
          matTooltipPosition="above" 
          color="warn"
          style="cursor: pointer;"
          > warning </mat-icon>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      #paginator
      [length]="length"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [pageSizeOptions]="[10, 25, 100]"
      (page)="getServerData($event)"
    ></mat-paginator>
  </div>
</div>
